import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Table,
  Button,
  InputGroup,
  Navbar,
  Nav,
} from "react-bootstrap";
import {
  FaSearch,
  FaWhatsapp,
  FaFileExcel,
  FaPrint,
  FaHome,
  FaSignOutAlt,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BanquetBookingHistory = () => {
  const tableRef = useRef();
  const navigate = useNavigate();

  const loginUser = JSON.parse(localStorage.getItem("loginUser"));

  const HOTEL_ID = loginUser?.hotelid;
  
  const [search, setSearch] = useState({
    name: "",
    mobile: "",
    fromDate: "",
    toDate: "",
  });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Fetch API
  const fetchEstimates = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://hotelapi.shriyanshnath.com/api/Get_estimates",
        {
          params: {
            hotelid: HOTEL_ID,
            fromdate: search.fromDate || "",
            todate: search.toDate || "",
            name: search.name || "",
            mobileno: search.mobile || "",
          },
        }
      );

      setData(response.data || []);
    } catch (error) {
      console.error("API Error", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchEstimates(); // page load par
  }, []);

  // 🔹 Excel
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Estimates");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      "Banquet_Estimates.xlsx"
    );
  };

  // 🔹 Print
  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  // 🔹 WhatsApp
  const sendWhatsApp = (mobile, name) => {
    const message = `Hello ${name}, regarding your banquet booking.`;
    window.open(
      `https://wa.me/91${mobile}?text=${encodeURIComponent(message)}`
    );
  };

  const sendEmail = (email) => {
    window.location.href = `mailto:${email}`;
  };

  const makeCall = (mobile) => {
    window.location.href = `tel:${mobile}`;
  };
  // 🔹 Logout
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      {/* 🔹 Header */}
      <Navbar bg="dark" variant="dark" className="px-3">
        <Navbar.Brand>Banquet Panel</Navbar.Brand>
        <Nav className="ms-auto gap-3">
          <Button variant="outline-light" onClick={() => navigate("/banquet")}>
            <FaHome /> Home
          </Button>
          <Button variant="outline-danger" onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </Button>
        </Nav>
      </Navbar>

      <Container className="my-4">
        <Card className="shadow">
          <Card.Body>
            <Row className="mb-3">
              <Col>
                <h4 className="fw-bold">Banquet Booking History</h4>
              </Col>
              <Col className="text-end">
                <Button variant="success" onClick={exportToExcel}>
                  <FaFileExcel /> Excel
                </Button>{" "}
                <Button variant="secondary" onClick={handlePrint}>
                  <FaPrint /> Print
                </Button>
              </Col>
            </Row>

            {/* 🔍 Filters */}
            <Row className="g-3 mb-3">
              <Col md={3}>
                <Form.Control
                  placeholder="Guest Name"
                  value={search.name}
                  onChange={(e) =>
                    setSearch({ ...search, name: e.target.value })
                  }
                />
              </Col>

              <Col md={3}>
                <Form.Control
                  placeholder="Mobile No"
                  value={search.mobile}
                  onChange={(e) =>
                    setSearch({ ...search, mobile: e.target.value })
                  }
                />
              </Col>

              <Col md={3}>
                <Form.Control
                  type="date"
                  value={search.fromDate}
                  onChange={(e) =>
                    setSearch({ ...search, fromDate: e.target.value })
                  }
                />
              </Col>

              <Col md={3}>
                <Form.Control
                  type="date"
                  value={search.toDate}
                  onChange={(e) =>
                    setSearch({ ...search, toDate: e.target.value })
                  }
                />
              </Col>
            </Row>

            <Row className="mb-4">
              <Col className="text-end">
                <Button onClick={fetchEstimates}>
                  <FaSearch /> Search
                </Button>
              </Col>
            </Row>

            {/* 📋 Table */}
            <div ref={tableRef}>
              <Table bordered hover responsive>
                <thead className="table-light">
                  <tr>
                    <th>Guest Name</th>
                    <th>Mobile</th>
                    <th>Party Type</th>
                    <th>Party Date</th>
                    <th>Amount (₹)</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : data.length > 0 ? (
                    data.map((item) => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>{item.mobileno}</td>
                        <td>{item.party_type}</td>
                        <td>{item.party_date?.split("T")[0]}</td>
                        <td>{item.total_amount}</td>
                        <td className="d-flex gap-1">
                          {/* WhatsApp */}
                          <Button
                            size="sm"
                            variant="success"
                            onClick={() =>
                              sendWhatsApp(item.mobileno, item.name)
                            }
                            title="WhatsApp"
                          >
                            <FaWhatsapp />
                          </Button>

                          {/* Email */}
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => sendEmail(item.email)}
                            title="Email"
                          >
                            <FaEnvelope />
                          </Button>

                          {/* Call */}
                          <Button
                            size="sm"
                            variant="secondary"
                            onClick={() => makeCall(item.mobileno)}
                            title="Call"
                          >
                            <FaPhoneAlt />
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No Records Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default BanquetBookingHistory;
